import { render, staticRenderFns } from "./FilterDistrictBlock.vue?vue&type=template&id=443331c3&"
import script from "./FilterDistrictBlock.vue?vue&type=script&lang=js&"
export * from "./FilterDistrictBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports